import { useState, useMemo, FC } from 'react'
import { getbrandsByText as getBrands } from '../../services/brandService'
import { Select, SelectProps } from 'antd'
import bxlUtils from 'bxl-utils'

const { Option } = Select

const BrandSelect: FC<SelectProps> = (props) => {
    const {
        value,
        onChange,
        mode,
        placeholder,
        showArrow = true,
        showSearch = true,
        allowClear = true,
        notFoundContent,
        optionFilterProp,
        ...properties
    } = props
        const [brands, setBrands] = useState([])
        const [loading, setLoading] = useState(false)
        const onSearch = useMemo(() => bxlUtils.debounce(500, value => {
        if (value) {
            setLoading(true)
            getBrands(value)
                .then(res => {
                    setTimeout(() => {
                        setBrands(res.data.brands)
                        setLoading(false)
                    }, 100)
                })
                .catch(e => {
                    setLoading(false)
                    setBrands([])
                })
        } else {
            setBrands([])
            setLoading(false)
        }
    }), [])

    return (
        <Select
            value={value}
            showSearch={showSearch}
            allowClear={allowClear}
            mode={mode}
            optionFilterProp={optionFilterProp || 'children'}
            placeholder={placeholder}
            defaultActiveFirstOption={false}
            showArrow={showArrow}
            filterOption={false}
            onSearch={onSearch}
            onChange={onChange}
            notFoundContent={notFoundContent}
            loading={loading}
            style={{width: 200}}
            {...properties}
        >
            {brands.map(item => (
                <Option value={item['id']} key={item['id']}>
                    {item['name']}
                </Option>
            ))}
        </Select>
    )
}

export default BrandSelect
